import React from 'react';
import clsx from 'clsx';

const stockLevels = {
  CRITICAL: {
    label: 'CRITICAL',
    classes: 'bg-accent-red/10 text-accent-red border-accent-red/20',
    pulse: true,
  },
  LOW: {
    label: 'LOW',
    classes: 'bg-accent-amber/10 text-accent-amber border-accent-amber/20',
    pulse: false,
  },
  NORMAL: {
    label: 'NORMAL',
    classes: 'bg-accent-green/10 text-accent-green border-accent-green/20',
    pulse: false,
  },
  HIGH: {
    label: 'HIGH',
    classes: 'bg-accent-blue/10 text-accent-blue border-accent-blue/20',
    pulse: false,
  },
  FULL: {
    label: 'FULL',
    classes: 'bg-purple-500/10 text-purple-400 border-purple-400/20',
    pulse: false,
  },
};

const transactionTypes = {
  BUY: {
    label: 'BUY',
    classes: 'bg-accent-green/10 text-accent-green border-accent-green/20',
  },
  SELL: {
    label: 'SELL',
    classes: 'bg-accent-red/10 text-accent-red border-accent-red/20',
  },
};

const connectionStatuses = {
  CONNECTED: {
    label: 'CONNECTED',
    classes: 'bg-accent-green/10 text-accent-green border-accent-green/20',
  },
  DISCONNECTED: {
    label: 'DISCONNECTED',
    classes: 'bg-accent-red/10 text-accent-red border-accent-red/20',
  },
};

export function getStockLevel(percentage) {
  if (percentage >= 100) return 'FULL';
  if (percentage >= 80) return 'HIGH';
  if (percentage >= 20) return 'NORMAL';
  if (percentage >= 10) return 'LOW';
  return 'CRITICAL';
}

export function getStockLevelColor(percentage) {
  const level = getStockLevel(percentage);
  const colorMap = {
    CRITICAL: '#ff3366',
    LOW: '#f59e0b',
    NORMAL: '#00ff88',
    HIGH: '#3b82f6',
    FULL: '#a855f7',
  };
  return colorMap[level];
}

export default function StatusIndicator({
  type = 'stock',
  value,
  label: customLabel,
  className = '',
}) {
  let config;

  if (type === 'stock') {
    const level = typeof value === 'number' ? getStockLevel(value) : (value || 'NORMAL');
    config = stockLevels[level] || stockLevels.NORMAL;
  } else if (type === 'transaction') {
    config = transactionTypes[value] || transactionTypes.BUY;
  } else if (type === 'connection') {
    config = connectionStatuses[value ? 'CONNECTED' : 'DISCONNECTED'];
  } else {
    config = stockLevels.NORMAL;
  }

  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1 px-2 py-0.5 rounded text-[11px] font-mono font-medium border',
        config.classes,
        config.pulse && 'animate-pulse',
        className
      )}
    >
      {config.pulse && (
        <span className="w-1.5 h-1.5 rounded-full bg-current animate-ping" />
      )}
      {customLabel || config.label}
    </span>
  );
}
